import axios from "axios";

const url = process.env.REACT_APP_BASE_API_URL;

//export async function reanaliseItemInsert(reanaliseItem) {
//  const headers = { 'Content-Type': 'application/json'};
//  return await axios.post(url + '/reanaliseitem/insert', reanaliseItem, {headers});
//}

export const reanaliseItemFindByReaid = async (reaId) => {
  const headers = { "Content-Type": "application/json" };
  return await axios.get(url + "/v1/reanaliseitem/findbyreaid/" + reaId, {
    headers,
  });
};

export const reanaliseItemInsert = async (reanaliseItem) => {
  const headers = { "Content-Type": "application/json" };
  return await axios.post(url + "/v1/reanaliseitem/insert", reanaliseItem, {
    headers,
  });
};

//export async function reanaliseItemInsert(reanaliseItem) {
//    const headers = { 'Content-Type': 'application/json'};
//    return await axios.post(url + '/v1/reanaliseitem/insert', reanaliseItem, {headers});
//  }

export function reanaliseItemUpdate(reanaliseItem) {
  const headers = { "Content-Type": "application/json" };
  return axios.put(url + "/v1/reanaliseitem/update", reanaliseItem, {
    headers,
  });
}

export const reanaliseItemDeleteAll = async (reanaliseItem) => {
  const headers = { "Content-Type": "application/json" };
  return await axios.delete(
    url + "/v1/reanaliseitem/deleteall",
    { data: reanaliseItem },
    { headers }
  );
};
